import React, { useRef } from 'react';
import RaisedButton from 'material-ui/RaisedButton';
import IconButton from 'material-ui/IconButton';
import Divider from 'material-ui/Divider';
import ContentRemoveIcon from 'material-ui/svg-icons/content/remove-circle-outline';
import api from '../../../../services';

/** @type {Record<string, import('react').CSSProperties>} */
const styles = {
    fileInput: {
        visibility: 'hidden',
        position: 'absolute',
        top: '-100000px',
        left: '-100000px',
    },
    link: {
        textDecoration: 'underline',
        color: '#4380C7',
    },
};

function Attachments({ attachments, changeField, confirmed }) {
    const fileRef = useRef();
    const hasAttachments = !!(attachments || []).length;
    const handleAdd = () => {
        const input = /** @type {HTMLInputElement} */(fileRef.current);
        const file = input.files[0];
        input.value = '';
        api.uploadFile({ file, type: 'attachment' })
            .then((res) => {
                const newAttachments = [...attachments, res.data.data];
                changeField({
                    field: 'attachmentsArray',
                    value: newAttachments,
                });
                changeField({
                    field: 'attachments',
                    value: newAttachments.map(a => a._id),
                });
            })
            .catch(console.error);
    };
    const handleRemove = (attachment) => {
        const newAttachments = attachments.filter(a => a._id !== attachment._id);
        changeField({
            field: 'attachmentsArray',
            value: newAttachments,
        });
        changeField({
            field: 'attachments',
            value: newAttachments.map(a => a._id),
        });
    };
    return (
        <React.Fragment>
            <div className='row' style={{ marginBottom: hasAttachments ? '16px' : '0' }}>
                <div className='col-xs-6'>
                    <span className='name-block static huge-name' style={{ lineHeight: '36px' }}>
                        ATTACHMENTS:
                    </span>
                </div>
                <div className="col-xs-2 col-xs-offset-4">
                    <RaisedButton
                        backgroundColor='white'
                        labelStyle={{ color:'#333', fontWeight: 'bold' }}
                        label='ADD'
                        onClick={() => /** @type {HTMLInputElement} */(fileRef.current).click()}
                        disabled={!confirmed}
                    />
                </div>
                <input
                    type='file'
                    name='files'
                    ref={fileRef}
                    style={styles.fileInput}
                    onChange={handleAdd}
                />
            </div>
            {attachments.map(attachment => (
                <React.Fragment>
                    <div className='row'>
                        <div className='col-xs-10' style={{ lineHeight: '48px', paddingLeft: '20px' }}>
                            <a
                                style={styles.link}
                                href={`/api/v1/file/${attachment.fileId}`}
                                download
                            >
                                {attachment.name}
                            </a>
                        </div>
                        <div className='col-xs-2' style={{ textAlign: 'right' }}>
                            <IconButton
                                disabled={!confirmed}
                                onClick={() => handleRemove(attachment)}
                            >
                                <ContentRemoveIcon color='red' />
                            </IconButton>
                        </div>
                    </div>
                    <Divider />
                </React.Fragment>
            ))}
        </React.Fragment>
    );
}

export default Attachments;



// WEBPACK FOOTER //
// ./app/components/Vessels/Single/Rows/Attachments.jsx